import { createContext } from "react";

const MobileViewerContext = createContext();

export default MobileViewerContext;